// components/modals/ConfirmModal.jsx
import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';
/**
 * General-purpose confirmation modal
 */
const ConfirmModal = ({ 
  show, 
  onHide,
  title,
  body,
  confirmText = 'Confirm',
  confirmVariant = 'primary',
  cancelText = 'Cancel',
  onConfirm,
  isLoading = false
}) => {
    useModalHistory(show, onHide, 'endowment-confirm-modal');

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {typeof body === 'string' ? <p className='text-white'>{body}</p> : body}
      </Modal.Body>
      
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide}
          disabled={isLoading}
        >
          {cancelText}
        </Button>
        <Button 
          variant={confirmVariant} 
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="mr-2"
              />
              Processing...
            </>
          ) : (
            confirmText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;